<template>
  <div>
    <div class="is-header">
      <section class="visible-md visible-lg m-pgtop">
        <div class="container">
          <p class="f-fl">欢迎访问睢宁县人民代表大会网站！</p>
          <ul class="f-fr">
            <li class="f-nbg">
              <a @click="setAsHomePage">设为首页</a>
            </li>
            <li>
              <a @click="AddFavorite">加入收藏</a>
            </li>
          </ul>
        </div>
      </section>
      <section class="m-banner">
        <div class="container" style="position: relative">
          <img src="../assets/imgs/pic-logo.png" alt="睢宁县人民代表大会" />
          <div class="m-search f-pr f-fr f-md-fn">
            <form method="" :action="'/search?keyWord=' + searchVal">
              <input type="hidden" value="search" />
              <input
                class="form-control u-searchtext"
                type="text"
                placeholder="请输入您要搜索的关键字"
                autocomplete="off"
                name="keyWord"
                required="required"
                v-model="searchVal"
              />
              <input class="u-searchbtn f-pa" type="submit" value="" />
            </form>
          </div>
        </div>
      </section>
      <section class="m-nav navbar-default f-pr">
        <div class="container" style="height: 60px">
          <div class="menuList">
            <ul>
              <li
                v-for="(menu, index) in menus"
                :key="index"
                @click="onRouter(menu.alias, menu.nav)"
              >
                <span :class="nav === menu.nav ? 'active' : ''">{{
                  menu.name
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
    <router-view :key="$route.fullPath" />
    <!--底部 on-->
    <div class="is-footer">
      <div class="container text-center f-pr">
        <p>
          主办单位（版权所有）：睢宁县人大常委会办公室&nbsp;&nbsp;&nbsp;内容未经允许严禁转载
        </p>
        <p>通讯地址：徐州睢宁县永康路&nbsp;&nbsp;&nbsp;邮编：221200</p>
        <p>
          <a tppabs="http://beian.miit.gov.cn/" target="_blank"
            >邮箱：snrd@163.com </a
          >&nbsp;&nbsp;&nbsp;<a target="_blank"
            ><img src="../assets/imgs/ga.png" alt="" /> 苏ICP备2024152581号</a
          >
        </p>
        <span id="_ideConac"
          ><a
            href="https://bszs.conac.cn/sitename?method=show&amp;id=0A00086AB75404B7E053022819ACE594"
            target="_blank"
            ><img
              id="imgConac"
              src="https://dcs.conac.cn/image/red.png"
              data-bd-imgshare-binded="1" /></a
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { listMenu } from "@/api/base";
export default {
  name: "layout",
  computed: {
    nav: {
      // 页签激活重构 ，active-tab  from store nav => compute => :class 表达式 ，路由跳转和页签激活关注点分离
      get() {
        // 用户直接访问 以下四个地址时，修正；可以不考虑这种特殊场景
        const path = this.$route.path;
        if (path.startsWith("/business/resources/2")) {
          return 2;
        }

        // 默认激活首页
        return this.$store.state.nav || 1;
      },
      set(value) {
        this.$store.commit("SET_NAV", value);
      },
    },
  },
  data() {
    return {
      menus: [
        // {
        //   name: "home",
        //   nav: 1,
        //   title: "网站首页",
        // },
        // {
        //   name: "person",
        //   nav: 2,
        //   title: "人大概况",
        // },
        // {
        //   name: "personNews",
        //   nav: 3,
        //   title: "人大新闻",
        // },
        // {
        //   name: "Supervision",
        //   nav: 4,
        //   title: "监督工作",
        // },
        // {
        //   name: "RepresentativeWork",
        //   nav: 5,
        //   title: "代表工作",
        // },
        // {
        //   name: "personTownStreet",
        //   nav: 6,
        //   title: "镇街人大",
        // },
        // {
        //   name: "partyConstruction",
        //   nav: 7,
        //   title: "党建工作",
        // },
        // {
        //   name: "personNationalCongress",
        //   nav: 8,
        //   title: "人大工作",
        // },
        // {
        //   name: "meetingMaterials",
        //   nav: 9,
        //   title: "会议资料",
        // },
      ],
      searchVal: "",
    };
  },
  methods: {
    setAsHomePage() {
      const currentUrl = window.location.href;
      if (document.all) {
        document.body.style.behavior = "url(#default#homepage)";
        document.body.setHomePage(currentUrl);
      } else {
        alert(
          "您好,您的浏览器不支持自动设置页面为首页功能,请您手动在浏览器里设置该页面为首页!"
        );
      }
    },
    //加入收藏
    AddFavorite() {
      let sURL = encodeURI(window.location);
      try {
        window.external.addFavorite(sURL, document.title);
      } catch (e) {
        try {
          window.sidebar.addPanel(document.title, sURL, "");
        } catch (e) {
          alert("加入收藏失败，请使用Ctrl+D进行添加,或手动在浏览器里进行设置.");
        }
      }
    },
    onRouter(route, nav) {
      this.nav = nav;
      this.$router.push({ name: route });
    },
    getMenuList() {
      listMenu().then((res) => {
        this.menus = [
          {
            alias: "home",
            nav: 1,
            name: "网站首页",
          },
        ];
        res.result.forEach((r, i) => {
          if (i < res.result.length - 1) {
            r.nav = i + 2;
            this.menus.push(r);
          }
        });
        localStorage.setItem("menus", JSON.stringify(res.result));
      });
    },
  },
  created() {
    localStorage.removeItem("menus");
    this.getMenuList();
  },
};
</script>

<style lang="less" scoped>
.is-footer p {
  margin-bottom: 0;
}
.m-pgtop {
  height: 42px;
}
.m-banner {
  padding: 96px 0;
  background: url("../assets/imgs/bg-banner.png") #fc2601 center bottom
    no-repeat;
}
.m-search .u-searchbtn {
  background: url("../assets/imgs/icon-search.png") center no-repeat;
}
.menuList {
  ul {
    display: flex;
  }
  li {
    width: 11.11%;
    line-height: 60px;
    text-align: center;
    span {
      cursor: pointer;
      position: relative;
      display: block;
      padding: 0 10px;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      overflow: hidden;
      word-wrap: normal;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .active {
      background: #b30000;
    }
    .active::after {
      width: 32px !important;
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 0;
      height: 4px;
      background: #fbdb05;
    }
    span:hover {
      background: #b30000;
    }
    span:hover::after {
      width: 32px;
      transition: 0.3s;
    }
    span::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 0;
      height: 4px;
      background: #fbdb05;
    }
  }
}
@media screen and (max-width: 1199px) {
  .menuList {
    li {
      span {
        font-size: 18px;
      }
    }
  }
}
@media screen and (max-width: 991px) {
  .menuList {
    li {
      span {
        padding: 0 5px;
        font-size: 18px;
      }
    }
  }
}
</style>
